import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import vintedCategories from '../data/categories';

// Vinted categories are the new default (replaces old defaultCategories)
const defaultCategories = vintedCategories;

const CategoriesContext = createContext({
  categories: defaultCategories,
  loading: false,
  reload: () => {},
});

export function CategoriesProvider({ children }) {
  const [categories, setCategories] = useState(defaultCategories);
  const [loading, setLoading] = useState(true);
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  const fetchCategories = useCallback(async () => {
    try {
      const { data } = await axios.get(`${backendUrl}/categories`);
      if (Array.isArray(data) && data.length > 0) {
        setCategories(data);
      }
    } catch {
      // keep defaultCategories as fallback
    } finally {
      setLoading(false);
    }
  }, [backendUrl]);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  return (
    <CategoriesContext.Provider value={{ categories, loading, reload: fetchCategories }}>
      {children}
    </CategoriesContext.Provider>
  );
}

export const useCategories = () => useContext(CategoriesContext);
